import { useEffect, useState } from "react";
import { Loader2, MessageSquareText } from "lucide-react";
import { toast } from "sonner";
import { errorMessage, get, put } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { SmsTokensAdmin } from "./SmsTokensAdmin";

export const SmsSettingsAdmin = () => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    get("/platform/sms-settings").then(setS).catch((e) => toast.error(errorMessage(e)));
  }, []);

  const toggle = async (enabled) => {
    setBusy(true);
    try {
      setS(await put("/platform/sms-settings", { enabled }));
      toast.success(enabled ? "Job texts turned on for every company" : "Job texts turned off for every company");
    } catch (e) {
      toast.error(errorMessage(e));
    } finally {
      setBusy(false);
    }
  };

  if (!s) return <div className="flex justify-center py-10"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;
  return (
    <div className="space-y-6">
    <section className="max-w-4xl space-y-4 rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-testid="sms-settings">
      <div className="flex items-start justify-between gap-4">
        <div className="flex gap-3">
          <MessageSquareText className="mt-0.5 h-5 w-5 shrink-0 text-blue-700" />
          <div>
            <h2 className="font-display text-lg font-bold text-slate-900">Job text messages</h2>
            <p className="mt-1 text-sm text-slate-600">When on, locksmiths with a phone number get a text when a run is assigned, changed or cancelled, using 1 of their company's text tokens. Turning this off stops texts for every company and no tokens are used. Emails keep sending.</p>
          </div>
        </div>
        <Switch checked={s.enabled} disabled={busy} onCheckedChange={toggle} aria-label="Send job texts sitewide" data-testid="sms-sitewide-switch" />
      </div>
      <p className={`text-sm font-medium ${s.enabled ? "text-emerald-700" : "text-rose-700"}`} data-testid="sms-sitewide-status">
        Texts are {s.enabled ? "on" : "off"} sitewide{s.updated_at ? ` · changed ${new Date(s.updated_at).toLocaleString("en-GB", { timeZone: "Europe/London" })}` : ""}
      </p>
      {!s.configured && <p className="rounded-lg bg-amber-50 p-3 text-sm text-amber-800" data-testid="sms-not-configured">Twilio isn't fully set up, so no texts will send even when this is on.</p>}
    </section>
    <SmsTokensAdmin />
    </div>
  );
};
